/**
 *
 * LegislatorPage Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */

import { LegislatorPage } from './lazyLegislatorPage';

// routes declaration
export const legislatorPageRoutes = [
  {
    component: LegislatorPage,
    path: '/legislator/:legislatorSlug',
    title: 'Legislator Page',
    needsAuth: true,
  },
];
